import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DefaultTable from "@bmi-digital/components/table";
import { RichText } from "./RichText";
import "./Table.css";
export const Table = ({ data, options }) => {
    if (!data.children?.length) {
        return null;
    }
    const numCols = Math.max(...data.children.map((row) => row.children.length));
    const isColumnEmpty = (colIndex) => {
        return data.children.every((row) => {
            const cell = row.children[colIndex];
            if (!cell || !cell.children || cell.children.length === 0) {
                return true;
            }
            return cell.children.every((child) => {
                if (child.type === "text") {
                    return !child.text?.trim();
                }
                if (child.type === "paragraph") {
                    return child.children.every((c) => c.type === "text" && !c.text?.trim());
                }
                return true;
            });
        });
    };
    const visibleColumnIndexes = Array.from({ length: numCols })
        .map((_, i) => i)
        .filter((i) => !isColumnEmpty(i));
    const renderCellContent = (children) => {
        const normalizedChildren = [];
        children.forEach((child) => {
            if (child.type === "paragraph") {
                normalizedChildren.push({ ...child, wrapTextInSpan: true });
            }
            else if (child.type === "text") {
                normalizedChildren.push({
                    type: "paragraph",
                    direction: data.direction,
                    format: "",
                    indent: 0,
                    version: 1,
                    textFormat: child.textFormat,
                    textStyle: "",
                    children: [child],
                    wrapTextInSpan: true
                });
            }
        });
        if (!normalizedChildren.length) {
            return null;
        }
        const richText = {
            root: {
                type: "root",
                direction: data.direction,
                format: "",
                indent: 0,
                version: 1,
                children: normalizedChildren
            }
        };
        return _jsx(RichText, { data: richText, options: options });
    };
    const headingRow = data.children[0];
    const dataRows = data.children.slice(1);
    return (_jsx("div", { className: "table-wrapper", children: _jsxs(DefaultTable, { children: [_jsx(DefaultTable.Head, { children: _jsx(DefaultTable.Row, { children: visibleColumnIndexes.map((colIndex) => (_jsx(DefaultTable.Cell, { children: headingRow?.children?.[colIndex]
                                ? renderCellContent(headingRow.children[colIndex].children)
                                : null }, colIndex))) }) }), _jsx(DefaultTable.Body, { children: dataRows.map((row, rowIndex) => (_jsx(DefaultTable.Row, { children: visibleColumnIndexes.map((colIndex) => {
                            const cell = row.children[colIndex];
                            return (_jsx(DefaultTable.Cell, { children: cell ? renderCellContent(cell.children) : null }, colIndex));
                        }) }, rowIndex))) })] }) }));
};
